import React, { useEffect, useState } from 'react';
import './Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || '';
const getToken = () => localStorage.getItem('notes_token') || '';

const fetchWithAuth = (url, options = {}) => {
  const token = getToken();
  return fetch(url, { ...options, headers: { ...options.headers, 'x-token': token } });
};

export default function PermissionManager() {
  const [users, setUsers] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = '';

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [usersRes, menuRes] = await Promise.all([
        fetchWithAuth(`${API_URL}/api/permissions`),
        fetchWithAuth(`${API_URL}/api/permissions/menu-items`)
      ]);
      const usersData = await usersRes.json();
      const menuData = await menuRes.json();
      if (usersData.success) setUsers(usersData.users);
      if (menuData.success) setMenuItems(menuData.items);
    } catch (e) {
      console.error(e);
      setMessage('加载失败');
    }
    setLoading(false);
  };

  const handleToggle = async (username, itemKey, hasPermission) => {
    if (saving) return;
    setSaving(true);
    try {
      const user = users.find(u => u.username === username);
      let newPerms;
      if (hasPermission) {
        newPerms = user.permissions.filter(p => p !== itemKey);
      } else {
        newPerms = [...user.permissions, itemKey];
      }
      
      const res = await fetchWithAuth(`${API_URL}/api/permissions/${username}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ permissions: newPerms })
      });
      const data = await res.json();
      if (data.success) {
        setUsers(users.map(u => 
          u.username === username ? { ...u, permissions: newPerms } : u
        ));
      } else {
        setMessage(data.error || '保存失败');
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (e) {
      setMessage('保存失败');
      setTimeout(() => setMessage(''), 3000);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="perm-loading">加载中...</div>;

  return (
    <div className="permission-manager">
      <div className="perm-header">
        <h2>🔐 权限管理</h2>
        <p className="perm-desc">为用户分配额外的功能访问权限（笔记、工单看板、补丁记录、知识库为默认可见）</p>
      </div>

      {message && <div className="perm-message">{message}</div>}

      <div className="perm-table">
        <div className="perm-table-header">
          <div className="perm-cell perm-cell-user">用户</div>
          {menuItems.map(item => (
            <div key={item.key} className="perm-cell perm-cell-item">
              <span className="perm-item-icon">{item.icon}</span>
              <span className="perm-item-label">{item.label}</span>
            </div>
          ))}
        </div>

        {users.map(user => (
          <div key={user.username} className="perm-table-row">
            <div className="perm-cell perm-cell-user">
              <span className="perm-username">{user.username}</span>
              <span className="perm-realname">{user.realname}</span>
            </div>
            {menuItems.map(item => {
              const hasPermission = user.permissions.includes(item.key);
              return (
                <div key={item.key} className="perm-cell perm-cell-check">
                  <button
                    className={`perm-toggle ${hasPermission ? 'active' : ''}`}
                    onClick={() => handleToggle(user.username, item.key, hasPermission)}
                    disabled={saving}
                    title={hasPermission ? '点击取消权限' : '点击授权'}
                  >
                    {hasPermission ? '✓' : ''}
                  </button>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
}